import MobilePlaceholder from './MobilePlaceholder'
export default MobilePlaceholder